import { useEffect, useState, useRef } from "react";
import axios from "axios";

const getApiUrl = () => {
  if (typeof window !== 'undefined') return `${window.location.origin}/api`;
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
};
const getWsUrl = () => {
  if (typeof window !== 'undefined') {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${protocol}//${window.location.host}`;
  }
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  return BACKEND_URL.replace('https://', 'wss://').replace('http://', 'ws://');
};
const API = getApiUrl();
const WS_URL = getWsUrl();

const spinnerStyles = `
@keyframes spin-border {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.logo-spinner-container {
  position: relative;
  width: 120px;
  height: 120px;
  margin: 0 auto 24px;
}
.logo-spinner-ring {
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 4px solid #e5e7eb;
  border-top: 4px solid #f5a623;
  animation: spin-border 1.2s linear infinite;
}
.logo-spinner-img {
  position: absolute;
  inset: 12px;
  border-radius: 50%;
  object-fit: cover;
  width: 96px;
  height: 96px;
}
`;

export default function WaitingPage() {
  const [status, setStatus] = useState("connecting");
  const [visitorId, setVisitorId] = useState(null);
  const wsRef = useRef(null);
  const registeredRef = useRef(false);

  useEffect(() => {
    if (registeredRef.current) return;
    const existingId = sessionStorage.getItem("visitor_id");
    if (existingId) {
      setVisitorId(existingId);
      setStatus("waiting");
      connectWebSocket(existingId);
      registeredRef.current = true;
      return;
    }
    registeredRef.current = true;
    const registerVisitor = async () => {
      try {
        const response = await axios.post(`${API}/visitors/register`);
        const visitor = response.data;
        if (visitor.status === "blocked" && visitor.redirect_url) {
          window.location.href = visitor.redirect_url;
          return;
        }
        setVisitorId(visitor.id);
        setStatus("waiting");
        sessionStorage.setItem("visitor_id", visitor.id);
        connectWebSocket(visitor.id);
      } catch (error) {
        const errorStatus = error.response?.status;
        const detail = error.response?.data?.detail || "";
        if (errorStatus === 503 || detail.includes("indisponível")) setStatus("offline");
        else if (errorStatus === 403 || detail.includes("bloqueado")) setStatus("blocked");
        else setStatus("error");
        registeredRef.current = false;
      }
    };
    registerVisitor();
    return () => { if (wsRef.current) wsRef.current.close(); };
  }, []);

  const connectWebSocket = (id) => {
    const ws = new WebSocket(`${WS_URL}/api/ws/visitor/${id}`);
    wsRef.current = ws;
    ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.type === "redirect" && data.url) window.location.href = data.url;
    };
    ws.onclose = () => { setTimeout(() => { if (visitorId && status === "waiting") connectWebSocket(visitorId); }, 3000); };
  };

  if (status === "offline") return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-900">
      <div className="text-center px-6">
        <span className="text-9xl font-bold text-red-500">500</span>
        <h1 className="text-3xl font-bold text-white mb-4 mt-6">Erro Interno</h1>
        <p className="text-zinc-400">Tente novamente mais tarde</p>
      </div>
    </div>
  );

  if (status === "blocked") return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-900">
      <div className="text-center px-6">
        <span className="text-9xl font-bold text-amber-500">403</span>
        <h1 className="text-3xl font-bold text-white mb-4 mt-6">Acesso Negado</h1>
        <p className="text-zinc-400">Acesso restrito por região</p>
      </div>
    </div>
  );

  return (
    <>
      <style>{spinnerStyles}</style>
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="text-center px-6">
          <div className="logo-spinner-container">
            <div className="logo-spinner-ring"></div>
            <img src="/logo-c6.png" alt="Carregando" className="logo-spinner-img" />
          </div>
          <h1 className="text-3xl font-bold text-zinc-800 mb-4">Aguarde</h1>
          <p className="text-zinc-500">Estamos iniciando o acesso a plataforma...</p>
        </div>
      </div>
    </>
  );
}
